import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

type OgType = 'og:url' | 'og:type' | 'og:title' | 'og:description' | 'og:image' | 'fb:app_id';

type OgAction = 'set' | 'update' | 'remove';

interface OgMetaFormat {
    type: OgType;
    value: string;
}

@Injectable({
    providedIn: 'root'
})
export class OpenGraphService {
    constructor(private meta: Meta) {}

    /**
     * Use this method to modify open graph tags
     * @param action
     * @param meta
     */
    public openGraphMeta(action: OgAction, ...meta: Optional<OgMetaFormat, 'value'>[]): void {
        meta.forEach(metaModel => {
            if (!metaModel.value) {
                this.removeOpenGraphMeta(metaModel);
                return;
            }

            this.applyAction(action, metaModel as OgMetaFormat);
        });
    }

    private applyAction(action: OgAction, meta: OgMetaFormat): void {
        if (action === 'remove') {
            return this.removeOpenGraphMeta(meta);
        }

        if (action === 'set') {
            return this.setOpenGraphMeta(meta);
        }

        if (action === 'update') {
            return this.updateOpenGraphMeta(meta);
        }

        throw new Error(`Invalid action recieved: ${action}`);
    }

    private setOpenGraphMeta(meta: OgMetaFormat): void {
        const currentTag = this.meta.getTag(`property="og:${meta.type}"`);

        if (currentTag) {
            this.updateOpenGraphMeta(meta);
            return;
        }

        this.meta.addTag({
            property: `${meta.type}`,
            content: meta.value
        });
    }

    private updateOpenGraphMeta(meta: OgMetaFormat): void {
        this.meta.updateTag({
            property: `${meta.type}`,
            content: meta.value
        });
    }

    private removeOpenGraphMeta(meta: Optional<OgMetaFormat, 'value'>): void {
        this.meta.removeTag(`property="${meta.type}"`);
    }
}
